import { format as formatDate } from 'date-fns';

export const exportToCSV = (data: any[], headers?: string[]): string => {
  if (data.length === 0) return '';

  // Auto-detect headers if not provided
  const csvHeaders = headers || Object.keys(data[0]);

  // Create CSV header row
  const headerRow = csvHeaders.map(h => `"${h}"`).join(',');

  // Create data rows
  const dataRows = data.map(item => {
    return csvHeaders.map(header => {
      const value = item[header];

      // Handle different data types
      if (value === null || value === undefined) return '';
      if (typeof value === 'string') return `"${value.replace(/"/g, '""')}"`;
      if (value instanceof Date) return `"${formatDate(value, 'yyyy-MM-dd HH:mm:ss')}"`;
      if (typeof value === 'object') return `"${JSON.stringify(value).replace(/"/g, '""')}"`;

      return value.toString();
    }).join(',');
  });

  return [headerRow, ...dataRows].join('\n');
};

export const exportToJSON = (data: unknown): string => {
  return JSON.stringify(data, null, 2);
};

export const downloadFile = (content: string, filename: string, mimeType: string): void => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
